module.exports = __webpack_public_path__ + "img/sph.3e5fe71f.png";